import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { atmosConstants, IAtmosConfig } from '..';

export const useAtmosConfigSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: IAtmosConfig) => {
      const res = await $api.post('/v1/atmos/config', data);

      return res?.data?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([atmosConstants.queryKeys.ATMOS_CONFIG]);
      }
    }
  );
};
